export default function fixNull<T = any>(value: any): T | "" {
  if (typeof value === "string" && value === "null") {
    return "";
  }

  return value;
}
